import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import ClaimStageViewAndUpdate from '~/components/ClaimStages/ClaimStageViewAndUpdate';
import useClaimStageConfigurations from '~/components/ClaimStages/hooks/useClaimStageConfigurations';

import GenericClaimBarField from './GenericClaimBarField';

const ClaimStage = ({ displayName = 'Stage' }: { displayName: string }) => {
  const { claim, asyncRefreshData } = useClaim({ claimRequired: true });
  const { isOperational } = useClaimStageConfigurations();

  return isOperational ? (
    <GenericClaimBarField
      title={displayName}
      content={<ClaimStageViewAndUpdate claimId={claim.id} stageKey={claim.stage_key} onUpdate={asyncRefreshData} />}
    />
  ) : null;
};

export default ClaimStage;
